class CartDrawer extends HTMLElement {
  constructor() {
    super();
    //this.updateCart();
    this.initElements();
  }

  initElements() {
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    this.continueBtn = this.querySelector('.cart-drawer .continue-btn');
    this.initEvents();
    if(document.querySelector('.cart-drawer .custom-checkout')){
      this.checkoutSubmit();
    }
  }
  initEvents(){
    this.continueBtn.addEventListener('click', this.close.bind(this));
  }
  checkoutSubmit(){
    let $this = this;
    document.querySelector('.cart-drawer .custom-checkout').addEventListener('click', function(event) {
      event.preventDefault();
      event.stopPropagation();
      let cart_items = document.querySelectorAll('#main-cart-items .cart-item');
      let correct_cart = false;
      let correct_item_count = 0;
      cart_items.forEach((item, i) => {
        let item_prop = item.getAttribute('data-full-prop');
        if(item_prop.length > 0 && item_prop.indexOf('_options') > -1 && item_prop.indexOf('_options_additional_price') > -1 || item_prop.length == 0 || item_prop.indexOf('_options') == -1){
          correct_item_count += 1;
        }else{
          item.querySelector('.prop_error').classList.add('active');
        }
      });
      if(correct_item_count == cart_items.length){
        correct_cart = true;
      }
      if(correct_cart){
        let btn = event.currentTarget;
        btn.classList.add('loading');
        btn.setAttribute('aria-disabled', true);
        let customer_id = btn.getAttribute('data-customer-id');
        let body;
        fetch('/cart.json').then(cart => cart.json()).then(cart => {
          if(customer_id != ''){
            body = {
              "line_items": cart.items,
              "customer": {id: customer_id}
            }
          }else{
            body = {
              "line_items": cart.items
            }
          }
          if(cart.token){
            body['token'] = cart.token;
          }
          fetch(`/apps/app-proxy/create-draft`, {body: JSON.stringify(body), method: 'POST'}).then(response => response.json()).then(response => {});
          btn.classList.remove('loading');
          btn.setAttribute('aria-disabled', false)
          window.location.href = '/checkout';
        })
      }


    });

  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active', 'animate');
    removeTrapFocus(this.activeElement);
    this.bodyRemoveFixed();
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
      if(document.querySelector('.cart-drawer .custom-checkout')){
        this.checkoutSubmit();
      }
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
  bodyRemoveFixed(){
    let bodyScrollY = parseInt(document.body.style.getPropertyValue('top'), 10);
    bodyScrollY = Math.abs(bodyScrollY);
    document.body.classList.remove('fixed', 'overflow-hidden');
    document.body.style.top = null;
    window.scrollTo(0, bodyScrollY);
  }
}

customElements.define('cart-drawer', CartDrawer);


class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
